import { isAxiosError } from 'axios'

import { getAdditionalHeaders } from '@/network/common/additionalHeaders'
import { store } from '@/reducers'
import { internalRequest } from '@/util/request'

import { getCookie } from '../providers/authentication/authentication.helpers'

interface SendMessageImageProps {
  image: File
  conversationId: string
}

export const sendMessageImage = async ({ image, conversationId }: SendMessageImageProps) => {
  const token = getCookie('token')

  const form = new FormData()

  try {
    form.append('files[]', image)

    const { data } = await internalRequest({
      headers: {
        authorization: token,
        'content-type': 'multipart/form-data',
        ...(await getAdditionalHeaders()),
      },
      data: form,
      url: `/conversations/${conversationId}/uploads-multipart`,
      method: 'POST',
      dispatch: store.dispatch,
    })

    return data
  } catch (error: any) {
    if (isAxiosError(error)) {
      return Promise.reject(error.response?.data)
    }

    throw error // Rethrow other errors
  }
}
